import { Service, inject } from '@angular/core'
import { EditUserBody, SetWalkMeBody, UserInfo } from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class UsersApiService {
  private readonly api = inject(ApiService)

  me(init?: RequestInit) {
    return this.api.protectedFetchJson<UserInfo>(`users/me`, { ...init })
  }

  setWalkMe(id: string, body: SetWalkMeBody, init?: RequestInit) {
    return this.api.fetchJson<boolean>(`users/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editUser(userId: string, body: EditUserBody, init?: RequestInit) {
    return this.api.protectedFetchJson<UserInfo>(`users/${userId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
